import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`bg-brand-green text-white font-semibold py-4 px-8 rounded-lg shadow-lg hover:shadow-brand-gold/20 hover:shadow-xl transition-all duration-300 border border-transparent hover:border-brand-gold/30 ${className}`} {...props} data-id="element-58">
      {children}
    </motion.button>;
}